import styled from "styled-components";

const FormStyled = styled.div`
  width: 100%;
  background-color: #eeeeee;
  box-shadow: 1px 1px 5px 1px #33333338;

  form {
    input[name="des"] {
      min-height: 200px;
      padding: 10px;
    }
  }
`;

export default FormStyled;
